import apiClient from "../../api";
import { callMyFreebies, getUserDetails, initializeLoyalty } from "../loyalty/loyalty";
import { getPrograms } from "../loyaltyprogram/loyaltyprogram";
import { pushPath } from "../navigation/navigation";
import { getPointsHistory } from "../pointshistory/pointshistory";
import { shopifySignUp } from "../signup/signup";
import { getThemeConfig, setTheme } from "../theme/theme";

const initialState = {
    merchantAccessToken: null,
    authToken: null,
    loyaltyId: null,
    shopifyCustomerId: null,
    showIntroduction: false,
    isEnrolled: null,
    knowMoreUrl: '',
    termsUrl: null,
    isMultiCountryEnable: null,
    multiCountryInfo: null,
};

const SET_TOKENS = 'loyaltyprogram/SET_TOKENS';
const SET_INTRO_INFO = "loyaltyprogram/SET_INTRO_INFO";
const CLOSE_INTRO_MODAL = "loyaltyprogram/CLOSE_INTRO_MODAL";
const SET_AUTH_TOKEN = "loyaltyprogram/SET_AUTH_TOKEN";
const GET_LOYALTY_ID = "loyaltyprogram/GET_LOYALTY_ID";

export const closeIntroModal = () => async (dispatch, getState) => {
    await dispatch({
        type: CLOSE_INTRO_MODAL,
    });
}

export const initialize = (merchantAccessToken, authToken, loyaltyId, shopifyCustomerId, horizontalStyle) => async (dispatch, getState) => {

    await Promise.all([
        dispatch({
            type: SET_TOKENS,
            merchantAccessToken,
            authToken,
            shopifyCustomerId,
            loyaltyId,
        }),
        dispatch(getLoyaltyId())]);

    dispatch(setTheme(horizontalStyle));
    dispatch(getThemeConfig());
}

export const initializeBenefits = (merchantAccessToken, authToken, loyaltyId) => async (dispatch, getState) => {
    await Promise.all([
        dispatch({
            type: SET_TOKENS,
            merchantAccessToken,
            authToken,
            loyaltyId,
        }),
        dispatch(getLoyaltyIdOnly())]);

    dispatch(getThemeConfig());
}


export const getLoyaltyIdOnly = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const { merchantAccessToken, loyaltyId, authToken } = state.session;

        if (loyaltyId) {
            dispatch(initializeLoyalty(loyaltyId));

        }
        else {

            const response = await apiClient.get(apiClient.Urls.loyaltyConfig, {
                merchantAccessToken,
                authToken
            });

            if (response.success) {

                const loyalty = response.config && response.config.loyalty;
                const loyaltyId = loyalty && loyalty.defaultLoyaltyId;

                const multiCountry = response.config && response.config.multiCountry;

                dispatch(initializeLoyalty(loyaltyId));

                await dispatch({
                    type: GET_LOYALTY_ID,
                    loyaltyId: loyaltyId,
                    multiCountryInfo: multiCountry
                });
            }
            else {
            }
        }
    } catch (error) {

    }
};



export const getLoyaltyId = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const { merchantAccessToken, loyaltyId, authToken } = state.session;

        if (loyaltyId) {
            dispatch(initializeLoyalty(loyaltyId));
            dispatch(getPrograms());
            dispatch(getUserDetails());
            dispatch(getPointsHistory());
        }
        else {

            const response = await apiClient.get(apiClient.Urls.loyaltyConfig, {
                merchantAccessToken,
                authToken
            });

            if (response.success) {

                const loyalty = response.config && response.config.loyalty;
                const loyaltyId = loyalty && loyalty.defaultLoyaltyId;

                const multiCountry = response.config && response.config.multiCountry;

                dispatch(initializeLoyalty(loyaltyId));

                await dispatch({
                    type: GET_LOYALTY_ID,
                    loyaltyId: loyaltyId,
                    multiCountryInfo: multiCountry
                });

                dispatch(getPrograms());
                dispatch(getUserDetails());
                dispatch(getPointsHistory());

            }
            else {
            }
        }
    } catch (error) {
    }
};

export const initializeHistory = (merchantAccessToken, authToken, loyaltyId) => async (dispatch, getState) => {

    await dispatch({
        type: SET_TOKENS,
        merchantAccessToken,
        authToken,
        shopifyCustomerId: null,
        loyaltyId,
    });

    await dispatch(getLoyaltyId());
    dispatch(getThemeConfig());
}

export const initializeRegistration = (merchantAccessToken, authToken, loyaltyId, shopifyCustomerId = null, postLoginCallback = null) => async (dispatch, getState) => {

    await dispatch({
        type: SET_TOKENS,
        merchantAccessToken,
        authToken,
        shopifyCustomerId,
        postLoginCallback,
        loyaltyId,
    });

    await dispatch(getLoyaltyId(loyaltyId));

    dispatch(getUserDetails());
    dispatch(getThemeConfig());
}


export const setupIntroInfo = (showIntroduction, isEnrolled, routeName) => async (dispatch, getState) => {
    await dispatch({
        type: SET_INTRO_INFO,
        showIntroduction,
        isEnrolled
    });
    routeName ?
        dispatch(pushPath(routeName, null)) :
        dispatch(pushPath(isEnrolled ? '/loyalty' : '/programs', null))
}

export const setAuthToken = (authToken) => async (dispatch, getState) => {

    await dispatch({
        type: SET_AUTH_TOKEN,
        authToken
    });

    dispatch(shopifySignUp());
    dispatch(getUserDetails());

}

const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TOKENS: {
            return {
                ...state,
                merchantAccessToken: action.merchantAccessToken,
                authToken: action.authToken,
                isMultiCountryEnable: action.isMultiCountryEnable,
                shopifyCustomerId: action.shopifyCustomerId,
                postLoginCallback: action.postLoginCallback,
                loyaltyId: action.loyaltyId,
            }
        }
        case SET_AUTH_TOKEN: {
            return {
                ...state,
                authToken: action.authToken,
            }
        }
        case SET_INTRO_INFO: {
            return {
                ...state,
                showIntroduction: action.showIntroduction,
                isEnrolled: action.isEnrolled,
            }
        }
        case CLOSE_INTRO_MODAL: {
            return {
                ...state,
                showIntroduction: false,
            }
        }
        case GET_LOYALTY_ID: {
            return {
                ...state,
                multiCountryInfo: action.multiCountryInfo,
                loyaltyId: action.loyaltyId
            }
        }

        default: return state;
    }

}


export default sessionReducer;